import Vue from 'vue';
import Router from 'vue-router';
const checkType = () => import(/* webpackChunkName: "checkType" */ '@/components/checkType.vue');
const signIn = () => import(/* webpackChunkName: "signIn" */ '@/components/signIn.vue');
const selectRound = () => import(/* webpackChunkName: "selectRound" */ '@/components/selectRound.vue');
const CheckInSystem = () => import(/* webpackChunkName: "CheckInSystem" */ '@/components/CheckInSystem.vue');
const Ticket = () => import(/* webpackChunkName: "Ticket" */ '@/components/Ticket.vue');
Vue.use(Router)

let router = new Router({
  base:"/carnival/",
  routes: [{
      path: '/',
      name: 'checkType',
      component: checkType,
      meta: {
        title: '-身份选择'
      }
    },
    {
      path:'/sign-in',
      name:'signIn',
      component:signIn,
      meta:{
        title:'-活动报名'
      }
    },
    {
      path: '/select-round',
      name: 'selectRound',
      component: selectRound,
      meta: {
        title: '-选择场次'
      }
    },
    {
      path: '/check-in-system',
      name: 'CheckInSystem',
      component: CheckInSystem,
      meta: {
        title: '-验票系统'
      }
    },
    {
      path: '/ticket',
      name: 'Ticket',
      component: Ticket,
      meta: {
        title: '-入场门票'
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  document.title = '深大开放日' + to.meta.title;
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js